/*
*
* File JS Principale
*
*/
// IMPORT JQUERY
//--------------------------------------------------------------------//

import $ from 'jquery';


// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import 'scss/app.scss';
import 'swiper/css/bundle';

//--------------------------------------------------------------------//

// Carichiamo i font in maniera asincrona
//--------------------------------------------------------------------//


var Webfont = require("webfontloader");

Webfont.load({
    google: {
        families: ["Montserrat:400,500,600,700,800&display=swap"]
    },
});



//--------------------------------------------------------------------//


// Libreria Lazysizes
//--------------------------------------------------------------------//
import 'lazysizes';

//--------------------------------------------------------------------//

// Import Utilies
//--------------------------------------------------------------------//

/*
import { initSvgImage } from './utilities/img-svg';
import initAnimations from './utilities/animations';
*/
import videoPlayer from 'components/video-player/video-player';
import smoothScroll from './utilities/smooth-scroll';
import { animation } from 'components/animation/animation';


//--------------------------------------------------------------------//


// Init Utilies
//--------------------------------------------------------------------//

smoothScroll();
animation();
/*
initSvgImage();
initAnimations();
*/

//--------------------------------------------------------------------//

//import videoNoPoster from './plugins/im-video-no-poster';


// Import Componenti
//--------------------------------------------------------------------//

import header from 'components/header/header';
import footer from 'components/footer/footer';
import accordion from 'components/accordion/accordion';
import modalCookie from 'components/modal-cookie/modal-cookie';


//--------------------------------------------------------------------//


// Init Componenti
//--------------------------------------------------------------------//

header();
accordion();
modalCookie();


//--------------------------------------------------------------------//